export const Types = {
    SAVE_LIST_RANK: 'SAVE_LIST_RANK',
    SET_RECORD: 'SET_RECORD'
}